import React from 'react';
import { Field } from 'redux-form';
import { useFormatMessage } from 'components/IntlProvider';

import Fields from 'components/Fields';

const Discount = () => {
  const t = useFormatMessage();
  return (
    <Field
      component={Fields.Text}
      variant="outlined"
      margin="normal"
      fullWidth
      label={t('fields.wizard.discount.label', 'Discount Code')}
      name="discount_code"
      placeholder={t(
        'fields.wizard.discount.placeholder',
        'ex. Cg2MqbFJj-036j9k'
      )}
      helperText={t(
        'fields.wizard.discount.helpertext',
        'If you have a discount code, please enter it here.'
      )}
      autoComplete="off"
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export default Discount;
